import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

export const authGuard: CanActivateFn = (_route, state) => {
  const msal = inject(MsalService);
  const router = inject(Router);

  const hasAccount =
    msal.instance.getActiveAccount() !== null ||
    msal.instance.getAllAccounts().length > 0;

  if (hasAccount) return true;

  router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
  return false;
};

export const loggedOutGuard: CanActivateFn = () => {
  const msal = inject(MsalService);
  const router = inject(Router);

  const hasAccount =
    msal.instance.getActiveAccount() !== null ||
    msal.instance.getAllAccounts().length > 0;

  if (hasAccount) {
    router.navigate(['/dashboard']);
    return false;
  }
  return true;
};
